import { useTranslation } from "../../i18n";
import { cn } from "../../utils";
import { Checkbox } from "../Checkbox";
import { Skeleton } from "../Skeleton";
import { useTableContext } from "./context";
import { TableHeaderCell } from "./TableHeaderCell";

type Props = {
  className?: string;
};

export function TableHeader({ className }: Props) {
  const { t } = useTranslation();
  const {
    columns,
    rowDensity,
    selection,
    loading,
    emptyState,
    gridTemplateColumns,
  } = useTableContext();

  const heightClass = {
    dense: "h-[42px]",
    default: "h-[52px]",
    expanded: "h-[60px]",
  }[rowDensity.value];

  const showSelection = !!selection;

  const isSelected =
    !!selection?.somePageItemsSelected || !!selection?.allPageItemsSelected;

  return (
    <div
      className={cn(
        "sticky top-0 bg-white border-b border-neutral-500/5 min-w-fit z-10",
        className,
      )}
      role="row"
    >
      <div
        className={cn("grid min-w-fit", heightClass)}
        style={{ gridTemplateColumns }}
      >
        {showSelection && (
          <div className="flex items-center justify-center min-w-0">
            {!emptyState &&
              (loading ? (
                <div className="w-4 h-4">
                  <Skeleton className="w-full h-full rounded-sm" />
                </div>
              ) : (
                <Checkbox
                  checked={isSelected}
                  indeterminate={selection.somePageItemsSelected}
                  onChange={selection.onSelectAllFromPage}
                  size="sm"
                  aria-label={t("table.selectAllItemsOnPageAriaLabel")}
                />
              ))}
          </div>
        )}
        {columns.map((column) => {
          return <TableHeaderCell key={column.key} column={column} />;
        })}
      </div>
    </div>
  );
}
